var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDownArrow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.99246 10.9812C7.83843 10.9798 7.69094 10.9187 7.58111 10.8107L1.76293 4.9925C1.65695 4.88277 1.59831 4.7358 1.59963 4.58325C1.60096 4.4307 1.66215 4.28477 1.77002 4.1769C1.87789 4.06902 2.02382 4.00783 2.17637 4.00651C2.32892 4.00518 2.47589 4.06383 2.58562 4.16981L7.99246 9.57665L13.3993 4.16981C13.453 4.11424 13.5172 4.06992 13.5882 4.03942C13.6591 4.00893 13.7355 3.99288 13.8127 3.99221C13.89 3.99154 13.9666 4.00626 14.0381 4.03551C14.1096 4.06477 14.1746 4.10797 14.2292 4.1626C14.2838 4.21723 14.327 4.28219 14.3563 4.35369C14.3855 4.42519 14.4003 4.50181 14.3996 4.57906C14.3989 4.65631 14.3829 4.73266 14.3524 4.80364C14.3219 4.87463 14.2776 4.93883 14.222 4.9925L8.40381 10.8107C8.29398 10.9187 8.14649 10.9798 7.99246 10.9812Z",
    fill: ""
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownArrow);
export default __webpack_public_path__ + "static/media/down-arrow.67962aad046ea59dc80d34aaef9721f4.svg";
export { ForwardRef as ReactComponent };